import {Component, EventEmitter, Host, Input, Optional, SkipSelf} from "@angular/core";
import {FormGroupContext} from "../../form-group-context.interface";
import {ControlContainer, ControlValueAccessor, FormControl} from "@angular/forms";

@Component({
  template: '',
})
export class FormGroupExtension implements FormGroupContext, ControlValueAccessor {

  @Input() formControlName: string;
  @Input() formControl: FormControl;

  value: any;
  disabled: any;

  valueChanges: EventEmitter<boolean | string> = new EventEmitter<boolean|string>();

  protected onTouched = () => {};

  protected onChange: (value: any) => void = () => {};

  constructor(@Optional() @Host() @SkipSelf() protected controlContainer: ControlContainer) {
  }

  registerControl() {
    if (!this.formControl && this.controlContainer) {
      if (this.formControlName) {
        this.formControl = this.controlContainer.control.get(this.formControlName) as FormControl;
      }
    }
  }

  registerOnChange(onChange: (value: any) => void) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: () => void) {
    this.onTouched = onTouched;
  }

  setDisabledState(disabled: boolean) {
    this.setDisabled(disabled);
  }

  writeValue(value: any) {
    this.setValue(value);
  }

  change(value) {
    this.value = value;
    this.valueChanges.emit(this.value);
    this.onChange(this.value);
  }

  setValue(value) {
    this.value = value;
  }

  setDisabled(disabled) {
    this.disabled = disabled;
  }
}
